module.exports = __webpack_public_path__ + "media/images/athletes/1710-55525af20e85d9bb97b5e19486bc2d97.png";